import "./NumberStepper.scss";
import PropTypes from "prop-types";

/**
 * Numeric +/- stepper with manual input, bounded to [min, max].
 * Controlled component: `value` (number) + `onChange(nextValue)`.
 * A non-numeric input falls back to the last valid value (min by default).
 */
const NumberStepper = ({
  value,
  onChange,
  min = 0,
  max,
  id,
  disabled,
  dataTestId,
}) => {
  const clamp = (v) => {
    let next = Number(v);
    if (Number.isNaN(next)) next = min;
    if (next < min) next = min;
    if (max !== undefined && next > max) next = max;
    return next;
  };

  const update = (next) => {
    if (disabled) return;
    onChange(clamp(next));
  };

  return (
    <div className="number-stepper" id={id}>
      <button
        type="button"
        className="number-stepper-btn"
        onClick={() => update(value - 1)}
        disabled={disabled || value <= min}
        aria-label="minus"
        data-testid={dataTestId ? `${dataTestId}-minus` : undefined}
      >
        −
      </button>
      <input
        className="number-stepper-value"
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={value}
        disabled={disabled}
        onChange={(e) => update(e.target.value)}
        aria-label="value"
        data-testid={dataTestId}
      />
      <button
        type="button"
        className="number-stepper-btn"
        onClick={() => update(value + 1)}
        disabled={disabled || (max !== undefined && value >= max)}
        aria-label="plus"
        data-testid={dataTestId ? `${dataTestId}-plus` : undefined}
      >
        +
      </button>
    </div>
  );
};

NumberStepper.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
};

export default NumberStepper;
